module.exports = __webpack_public_path__ + "static/boothLogo-de5773b7accc000a0a126f09a27a2ee2.png";